export default "__VITE_ASSET__BRo4cHBp__"